import SocialMediaSharing from './social-media-sharing';
import FeedFilters from './feed-filters';
import ArticleAuthorsSlider from './article-authors-slider';
import PremiumContent from './premium-content';
import PremiumVideo from './premium-video';

export default [
  new FeedFilters('.js-feed-filters'),
  new PremiumContent('.js-premium-content'),
  new PremiumVideo(
    '.js-premium-player-wrapper',
    'js-premium-player',
    '.js-proceed-to-subscribe',
  ),
  new ArticleAuthorsSlider(),
  new SocialMediaSharing(),
];
